import { useMutation } from "@tanstack/react-query";
import axios from "../axios";

const useGenerateForgetPasswordToken = () => {
  const mutation = useMutation({
    mutationFn: async (params) => {
      const response = await axios.post("/api/auth/forget-password", {
        email: params.email,
      });
      return response;
    },
  });

  return mutation;
};

export default useGenerateForgetPasswordToken;
